var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39838 0.14198C9.87254 -0.109196 11.3843 -0.026339 12.8222 0.384443C14.26 0.795225 15.5874 1.52346 16.7064 2.51546L16.768 2.57043L16.8247 2.52046C17.8926 1.58322 19.1482 0.884498 20.5076 0.470908C21.867 0.0573169 23.299 -0.0616331 24.708 0.121993L25.1177 0.181955C26.8937 0.488608 28.5538 1.26985 29.9221 2.44296C31.2903 3.61607 32.3159 5.13737 32.8901 6.84576C33.4644 8.55415 33.5659 10.386 33.184 12.1474C32.8021 13.9088 31.951 15.5342 30.7208 16.8513L30.421 17.1594L30.341 17.2277L17.9323 29.5182C17.6459 29.8016 17.2666 29.9716 16.8644 29.9968C16.4623 30.0219 16.0647 29.9004 15.7453 29.6548L15.5888 29.5182L3.10842 17.1561C1.7863 15.8697 0.846034 14.2424 0.391756 12.4546C-0.0625214 10.6667 -0.013082 8.78795 0.534599 7.02644C1.08228 5.26493 2.10683 3.68938 3.49478 2.47428C4.88273 1.25917 6.57992 0.451943 8.39838 0.14198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabFavorites);
export default __webpack_public_path__ + "static/media/tabFavorites.43b0083f88a2054929b4ae6af440dc7a.svg";
export { ForwardRef as ReactComponent };